import { FC, SVGAttributes } from 'react';

const FilledCheck: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 9C17 4.58141 13.4177 1 9 1C4.58141 1 1 4.58141 1 9C1 13.4177 4.58141 17 9 17C13.4177 17 17 13.4177 17 9ZM12.8347 7.20959C13.0885 6.95573 13.0884 6.54417 12.8346 6.29035C12.5807 6.03653 12.1692 6.03655 11.9153 6.29041L7.87554 10.3308L6.08455 8.54032C5.83068 8.28651 5.41912 8.28657 5.16532 8.54045C4.91151 8.79432 4.91157 9.20588 5.16545 9.45968L7.41608 11.7097C7.66994 11.9635 8.08147 11.9634 8.33528 11.7096L12.8347 7.20959Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default FilledCheck;
